import { useState, useEffect } from 'react';
import { BlogType } from 'types';
import api from 'api';
import { Link } from 'react-router-dom';
import "./blogs.scss";

function Blogs() {
    const [blogs, setBlogs] = useState<BlogType[]>([]);

    function onGetBlogs() {
        api.blogs.getAll().then((data: BlogType[]) => {
            data = data.sort((a, b) => new Date(b.DateCreated).getTime() - new Date(a.DateCreated).getTime());
            setBlogs(data);
        })
    }

    useEffect(() => {
        onGetBlogs();
    }, []);

    return (
        <div className="container" id="blogs">
            <div className="blogs-container">
                {blogs.map((item: BlogType, i: number) => {
                    return (
                        <Link to={`blog/${item.Id}-${item.UniqueURL}`} key={i}>
                            <div className="blog" key={item.Id}>
                            <div
                                className="blog-background"
                                style={{
                                background: `url('https://app-api.amasocial.co.za/api/blog/image/${item.ImagePath}'), url(img/placeholder.jpg)`,
                                }}
                            ></div>
                            <p
                                className="blog-heading"
                                dangerouslySetInnerHTML={{ __html: item.Headline }}
                            ></p>
                            <p
                                className="blog-synopsis"
                                dangerouslySetInnerHTML={{ __html: item.Synopsis }}
                            ></p>
                            </div>
                        </Link>
                    );
                })}
            </div>
      </div>
    )
}

export default Blogs;